import { api } from '../instance';
export const canAccessPaidFeatures = () => {
    return api.get('/subscription/can-access-paid-features');
};
//# sourceMappingURL=can-access-paid-features.api.js.map